import { Box } from "@mui/material";

export const InternalError = () => {
  return <Box flex={1}></Box>;
};
